<template>
    <section class="404-section">
        <div class="columns">
            <div class="column is-full has-text-centered m-t-xl">
                <h1 class="is-size-1 title" style="font-size: 90px !important;">404</h1>
                <h3>
                    <b>Oops! This Page Could Not Be Found</b>
                </h3>
                <p>
                    SORRY BUT THE PAGE YOU ARE LOOKING FOR DOES NOT EXIST, HAVE BEEN REMOVED.
                    <br>NAME CHANGED OR IS TEMPORARILY UNAVAILABLE
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "PageNotFound" // you can enter any name (optional)
};
</script>